<template>
    <div class="profile-compare bg--layer-dark mb--sm">
        <div class="row row--no-gutters" v-for="match in matches">
            <div class="col-6" v-for="(matchUser, index) in match.quizUsers">
                <div :class="['profile', 'profile--inline', 'profile--horizontal', {'profile--right': index > 0, 'bg--primary': index === 0 && matchUser.won === 1, 'bg--secondary': index === 1 && matchUser.won === 1}]">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img"><img src="/img/pictures/avatar-1.jpg" alt="" /></span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name profile__name--max-width">{{ matchUser.nick }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['matches']
    }
</script>

<style scoped>

</style>